<template>
  <section id="food-detail">
    <Navbar />
    <div class="container mt-3">
      <div class="title-section">
        <h3>Food <strong>Detail</strong></h3>
      </div>

      <!-- Breadcrumb -->
      <nav aria-label="breadcrumb" class="my-3">
        <ol class="breadcrumb bg-transparent">
          <li class="breadcrumb-item">
            <router-link to="/"><span class="link">Home</span></router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/foods"
              ><span class="link">Foods</span></router-link
            >
          </li>
          <li class="breadcrumb-item active">
            <span class="link-active">{{ product.nama }}</span>
          </li>
        </ol>
      </nav>

      <!-- Food Detail -->
      <section id="food">
        <div class="row">
          <div class="col-md-6 my-2 d-sm-block d-md-none">
            <div class="food-description">
              <h3>
                <strong>{{ product.nama }}</strong>
              </h3>
              <h5>
                Harga: <strong>Rp. {{ product.harga }}</strong>
              </h5>
            </div>
            <hr />
          </div>
          <div class="col-md-6">
            <img
              :src="require(`../assets/images/${product.gambar}`)"
              alt="img-food"
              class="img-fluid rounded shadow"
            />
          </div>
          <div class="col-md-6">
            <div class="food-description d-sm-none d-md-block">
              <h3>
                <strong>{{ product.nama }}</strong>
              </h3>
              <h5>
                Harga: <strong>Rp. {{ product.harga }}</strong>
              </h5>
            </div>
            <hr />

            <!-- Form Pesanan -->
            <div class="food-form">
              <form action="post" class="mt-3" v-on:submit.prevent>
                <label for="food-jumlah" class="form-label">Jumlah</label>
                <input
                  v-model="pesanan.jumlah_pesanan"
                  id="food-jumlah"
                  class="form-control"
                  type="number"
                  placeholder="Pesan berapa?"
                />
                <label for="food-catatan" class="form-label mt-3"
                  >Catatan</label
                >
                <textarea
                  v-model="pesanan.catatan"
                  id="food-catatan"
                  class="form-control"
                  type="text"
                  placeholder="Catatan: Tidak Pedas / Pedas"
                />
                <button
                  class="btn btn-success btn-block mt-4"
                  type="submit"
                  @click="pesanMakanan"
                >
                  <b-icon icon="cart"></b-icon>
                  Pesan
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import { API_URL } from "../utils/constant.js";

import Navbar from "../components/Navbar.vue";

export default {
  name: "FoodDetail",
  data() {
    return {
      product: {},
      pesanan: {},
    };
  },
  components: {
    Navbar,
  },
  methods: {
    setProduct(data) {
      this.product = data;
    },
    pesanMakanan() {
      if (this.pesanan.jumlah_pesanan) {
        this.pesanan.product = this.product;
        axios
          .post(API_URL + "/pesanan", this.pesanan)
          .then((res) => {
            console.log(`Berhasi Pesan :`, res.data);
            this.$router.push({ path: "/pesanan" });
            this.$toast.success(`Berhasil Pesan ${this.product.nama}`, {
              position: "top-right",
            });
          })
          .catch((err) => {
            console.log(`Gagal Pesan :`, err);
            this.$toast.error(`Gagal Memesan ${this.product.nama}`, {
              position: "top-right",
            });
          });
      } else {
        this.$toast.error(`Jumlah Wajib Diisi yaa :D`, {
          position: "top-right",
        });
      }
    },
  },
  mounted() {
    // Get Food By Id
    axios
      .get(API_URL + `/products/${this.$route.params.id}`)
      .then((res) => {
        console.log(`food detail`, res.data);
        this.setProduct(res.data);
      })
      .catch((err) => {
        console.log(`err`, err);
      });
  },
};
</script>

<style scope>
.link {
  color: #00b95d;
}

.breadcrumb-item a {
  text-decoration: none !important;
}

.breadcrumb-item a:hover {
  color: #00944a;
  font-weight: 400;
}

.link-active {
  color: #00b95d;
  font-weight: bold;
}
</style>
